
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie",
      function () {
        return require("private-next-pages/cookie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookie"])
      });
    }
  